// Adapter: the copied Risk Framework code was written against react-query v3
// (positional useQuery(key, fn, options), invalidateQueries(key)). The dashboard
// runs React 19, which needs @tanstack/react-query v5, so these wrappers keep the
// copied files unchanged.
import {
  QueryClient,
  QueryClientProvider,
  keepPreviousData,
  useQuery as useQueryV5,
  useQueryClient as useQueryClientV5,
} from "@tanstack/react-query";

export { QueryClient, QueryClientProvider };

export function useQuery(key, queryFn, options = {}) {
  const { keepPreviousData: keepPrevious, cacheTime, ...rest } = options;
  return useQueryV5({
    queryKey: Array.isArray(key) ? key : [key],
    queryFn,
    ...(keepPrevious ? { placeholderData: keepPreviousData } : {}),
    ...(cacheTime !== undefined ? { gcTime: cacheTime } : {}),
    ...rest,
  });
}

export function useQueryClient() {
  const client = useQueryClientV5();
  return {
    invalidateQueries: (key, filters) =>
      client.invalidateQueries({ queryKey: Array.isArray(key) ? key : [key], ...filters }),
  };
}
